/**
 * om-availability-override.js
 *
 * Companion to the custom.availability_override variant metafield.
 *
 * The server-rendered markup is authoritative: product-info.js reads the
 * freshly fetched submit button's `disabled` attribute on every variant
 * switch, so a blocked variant always disables the button without help.
 * But the label it writes for a disabled button is always
 * theme.strings.soldOut. This subscriber runs after that (variantChange is
 * published last) and rewrites the label to "Coming soon" when the fetched
 * button carries data-coming-soon="true", mirroring toggleSubmitButton's
 * price-preserving text swap.
 */
(function () {
  'use strict';

  // The snippet-level script tag can render more than once per page
  // (quickview + PDP); run the subscriber once.
  if (window.__omAvailabilityOverrideInit) return;
  window.__omAvailabilityOverrideInit = true;

  function init() {
    if (typeof subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) return;

    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;

      var fetched = data.html.querySelector('#ProductSubmitButton-' + data.sectionId);
      if (!fetched || fetched.dataset.comingSoon !== 'true' || !fetched.hasAttribute('disabled')) return;

      var live = document.getElementById('ProductSubmitButton-' + data.sectionId);
      var textEl = live && live.querySelector('[data-add-to-cart-text]');
      if (!textEl) return;

      var text = (window.theme.strings && window.theme.strings.comingSoon) || 'Coming soon';
      var price = textEl.querySelector('[data-product-price]');
      if (price) {
        var priceHTML = price.outerHTML;
        textEl.textContent = text;
        textEl.insertAdjacentHTML('beforeend', ' ' + priceHTML);
      } else {
        textEl.textContent = text;
      }
    });
  }

  // Deferred, so the DOM is parsed and theme.dev.js (subscribe) has already run: start now rather than on
  // DOMContentLoaded, which Cookiebot auto-blocking holds back for seconds.
  if (document.readyState === 'loading' || typeof subscribe !== 'function') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
